var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable @typescript-eslint/explicit-function-return-type,@typescript-eslint/explicit-module-boundary-types */
import { serialize } from 'cookie';
import { parseCookies, mergeCookies, mergeHeaders } from './serviceUtils';
import { initializeApollo } from './apolloClient';
import { configService } from '@next-common/config-service';
import { computeTrackingWithQuery } from './tracking';
import { initializeStore } from './redux';
import { regroupModuleReducers } from './regroupModuleReducers';
import { createAxiosInstance } from './createAxiosInstance';
import { TrackingApi } from '@next-common/tech-ws-client';
import { extractHeadersForWs, extractParamsForWs } from './genericService';
export const reduxModuleServiceLoadInitalAction = (context, modules, store, baseUrl = null, preloadedConfig = {}) => {
    // Create Store with Reducers from moduels
    // call inital Actions for moduels
    const initalActionPromises = [];
    modules.forEach((module) => {
        if (typeof module.initalAction === 'function') {
            // const start = moment();
            initalActionPromises.push(
            // @ts-expect-error AnyActoin
            store.dispatch(module.initalAction(context, baseUrl, preloadedConfig))
            // .catch((err) => {
            //   /* eslint-disable no-param-reassign */
            //   // err.service = name;
            //   // const error = serviceUtils.extractErrorMessage(err);
            //   // watcher.addTask(watchContext, name.toUpperCase(), moment() - start, 'KO', error);
            //   // logger.error(`ERROR=${error}`, { req: context.req });
            //   // console.error(`ERROR=${error}`, { req: context.req });
            //   throw err;
            // }),
            );
        }
    });
    return Promise.all(initalActionPromises);
};
function respMergeSetCookieHeader(resp, setCookieStringArray) {
    if (setCookieStringArray.length > 0) {
        // merge new set cookies with exising set cookies headers
        const previousCookies = resp.getHeader('set-cookie');
        resp.setHeader('set-cookie', [
            // eslint-disable-next-line no-nested-ternary
            ...(typeof previousCookies === 'string' ? [previousCookies] : Array.isArray(previousCookies) ? previousCookies : []),
            setCookieStringArray.join(', '),
        ]);
    }
}
function respAddCookie(resp, name, value, options) {
    respMergeSetCookieHeader(resp, [serialize(name, String(value), options)]);
}
function respAddSetCookieHeader(resp, mapSetCookieHeaders) {
    /* eslint-disable no-underscore-dangle */
    const cookieMap = new Map();
    const values = Array.from(mapSetCookieHeaders.values());
    values.forEach((cookieString) => {
        const cookies = parseCookies(Array.from(cookieString).join(''));
        mergeCookies(cookieMap, cookies);
    });
    const setCookieString = [];
    cookieMap.forEach((cookie) => {
        if (cookie.maxAge) {
            // eslint-disable-next-line
            cookie.maxAge = cookie.maxAge;
            // eslint-disable-next-line
            cookie.expires = new Date(Date.now() + cookie.maxAge);
        }
        setCookieString.push(serialize(cookie.name, String(cookie.value), cookie));
    });
    respMergeSetCookieHeader(resp, setCookieString);
}
export const forwardAPIResponseHttpHeaderToBrowser = (apiResponseHeaders, context) => {
    const mapSetCookieHeaders = new Map();
    let inpuHeader = apiResponseHeaders;
    if (!(inpuHeader instanceof Map)) {
        inpuHeader = new Map(Object.entries(apiResponseHeaders));
    }
    mergeHeaders(mapSetCookieHeaders, inpuHeader);
    respAddSetCookieHeader(context.res, mapSetCookieHeaders);
};
export const getServerSidePropsLoader = (context, modules, baseUrl, preloadedConfig, PAGE_QUERY, graphQlvariables) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const config = configService.get();
    const reducers = regroupModuleReducers(modules);
    const store = initializeStore({}, reducers);
    const enhancedPreloadedConfig = Object.assign({}, preloadedConfig);
    const onResponseHeader = (headers) => {
        forwardAPIResponseHttpHeaderToBrowser(headers, context);
    };
    const apolloClient = initializeApollo(null, {
        onResponseHeader,
    });
    const graphQlContext = {};
    if (context.req) {
        const extractedHeaders = extractHeadersForWs(context.req.headers);
        graphQlContext.headers = extractedHeaders;
    }
    if (context.query) {
        const extractedParams = extractParamsForWs(context.query);
        graphQlContext.headers = Object.assign({}, graphQlContext.headers, extractedParams);
    }
    const modulePromises = reduxModuleServiceLoadInitalAction(context, modules, store, baseUrl, enhancedPreloadedConfig);
    const ssrPromises = [modulePromises];
    if (PAGE_QUERY) {
        ssrPromises.push(apolloClient.query({
            query: PAGE_QUERY,
            variables: graphQlvariables,
            context: graphQlContext,
        }));
    }
    if ((_a = context === null || context === void 0 ? void 0 : context.query) === null || _a === void 0 ? void 0 : _a.t) {
        const axiosInstance = createAxiosInstance({
            context,
            moduleName: 'TechWS',
        });
        const techService = new TrackingApi(undefined, config.backendTechUrl, axiosInstance);
        ssrPromises.push(techService.tracking(context.query.t).then((trackingData) => {
            if (trackingData === null || trackingData === void 0 ? void 0 : trackingData.data.id) {
                const pmCookieValue = computeTrackingWithQuery(context.query, trackingData.data.id, context.req.cookies.pm);
                respAddCookie(context.res, 'pm', pmCookieValue, {
                    maxAge: 2629746,
                    path: '/',
                    encode: (s) => s, // no addition url encoding
                });
            }
        }));
    }
    yield Promise.all(ssrPromises);
    return {
        store,
        apolloClient,
        initialReduxState: store.getState(),
        initialApolloState: apolloClient.cache.extract(),
    };
});
